import { render, staticRenderFns } from "./CalendarAstrolabePopup.vue?vue&type=template&id=0c6ddde0&"
import script from "./CalendarAstrolabePopup.vue?vue&type=script&lang=js&"
export * from "./CalendarAstrolabePopup.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAstrolabePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6ddde0')) {
      api.createRecord('0c6ddde0', component.options)
    } else {
      api.reload('0c6ddde0', component.options)
    }
    module.hot.accept("./CalendarAstrolabePopup.vue?vue&type=template&id=0c6ddde0&", function () {
      api.rerender('0c6ddde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2025/CalendarAstrolabePopup.vue"
export default component.exports